import React, { useContext } from "react";
import ReceptionOverview from "structure/ReceptionOverview";
import { ContextReceiveCreditNote } from "..";

export default function Step2() {
  const hook = useContext(ContextReceiveCreditNote);

  return <ReceptionOverview uuid={hook.xml.xmlInfo.cfdiRelacionados} />;
}
